export default __webpack_public_path__ + "static/media/audit9.636484d7.jpg";